export default __webpack_public_path__ + "static/assets/3ef47cd9de72c9490a311df93fef27af.png";